export const defaultMaxFiles = 1;

export const defaultAcceptedFiles = {
  'image': ['.jpg', '.png', '.jpeg']
}

export const defaultMaxSize = 5242880;

export const dragDropDefaultProps = {
	maxFiles: defaultMaxFiles,
	accept: defaultAcceptedFiles,
	maxSize: defaultMaxSize,
	multiple: false,
}